import { render, staticRenderFns } from "./HistoryResults.vue?vue&type=template&id=63f2c6a2&"
import script from "./HistoryResults.vue?vue&type=script&lang=js&"
export * from "./HistoryResults.vue?vue&type=script&lang=js&"
import style0 from "./HistoryResults.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports